import { createStore, applyMiddleware, combineReducers } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import stockReducer from './reducers/stock'
import userReducer from './reducers/user'
import watchlistReducer from './reducers/watchlist'
import { createTracker } from 'redux-segment';

const tracker = createTracker();

const reducer = combineReducers({
  stock: stockReducer,
  user: userReducer,
  watchlist: watchlistReducer
})

export default createStore(reducer, composeWithDevTools(
  applyMiddleware(thunk, tracker)
));



// WEBPACK FOOTER //
// ./src/store.js